<div class="panelContent">
	<sim-component-loading-container
		[isLoading]="loadingSets"
		[loadingMessage]="T.GLOBAL_TEXT_LOADING | translate"
		loadingIcon="fad fa-download"
	/>

	@if (fileSets?.length <= 0 && !loadingSets) {
		<div class="noExportsCon">
			<div class="noExportsIcon">
				<i class="fad fa-download fa-4x"></i>
			</div>
			<div class="noExprotsTxt">
				{{ T.RECORDINGS_FILESET_PANEL_NONE_FOUND | translate }}
			</div>
		</div>
	}

	@if (fileSets?.length > 0) {
		<div class="exportsContainer" [@listStagger]="fileSets?.length">
			@for (conversionInfo of fileSets; track TrackByMethods.trackByConversionInfo($index, conversionInfo)) {
				@if (conversionInfo.visualState !== ExportVisualState.Dismissed) {
					<div class="export">
						<div class="nameOfFileSet">
							{{ conversionInfo.fileSetDisplayName }}
						</div>
						<div class="roomOfFileSet">
							<mat-icon fontSet="fad" fontIcon="fa-door-open" />
							{{ conversionInfo.trainingRoomName }}
						</div>
						<div
							class="exportDate date"
							*ngVar="conversionInfo.scenarioRecordingId | getScenarioRecordingById | async as scenarioRecording"
						>
							@if (scenarioRecording) {
								<mat-icon fontSet="fad" fontIcon="fa-clock" />
								{{ scenarioRecording.recordingTimeMs | minsec }}
							}
						</div>
						<mat-divider class="dividerToActions" />
						<div class="exportActions">
							<ng-container>
								@switch (conversionInfo.conversionState) {
									@case (ExportState.Finished) {
										<button
											mat-icon-button
											color="warn"
											style="margin-right: 20px"
											(click)="deleteConversion(conversionInfo.conversionProcessInfoId)"
										>
											<mat-icon fontSet="fad" fontIcon="fa-trash-alt" inline />
										</button>
									}
								}
							</ng-container>
							<ng-container>
								@switch (conversionInfo.visualState) {
									@case (ExportVisualState.Terminated) {
										<button
											mat-raised-button
											color="warn"
											(click)="dismissConversion(conversionInfo.conversionProcessInfoId)"
										>
											<i class="fas fa-remove"></i>
											{{ T.RECORDINGS_FILESET_PANEL_DISMISS | translate }}
										</button>
									}
									@case (ExportVisualState.Default) {}
								}
							</ng-container>
							@switch (conversionInfo.conversionState) {
								@case (ExportState.Exporting) {
									<button
										mat-icon-button
										color="accent"
										(click)="cancelConversion(conversionInfo.conversionProcessInfoId)"
									>
										<mat-icon fontSet="fad" fontIcon="fa-times" inline />
									</button>
									<button mat-icon-button color="warn" (click)="pauseConversion(conversionInfo.conversionProcessInfoId)">
										<mat-icon fontSet="fad" fontIcon="fa-pause" inline />
									</button>
								}
								@case (ExportState.Paused) {
									<button
										mat-icon-button
										color="accent"
										(click)="cancelConversion(conversionInfo.conversionProcessInfoId)"
									>
										<mat-icon fontSet="fad" fontIcon="fa-times" inline />
									</button>
									<button mat-icon-button color="warn" (click)="resumeConversion(conversionInfo.conversionProcessInfoId)">
										<mat-icon fontSet="fad" fontIcon="fa-play" inline />
									</button>
								}
								@case (ExportState.Idle) {
									<button
										mat-icon-button
										color="accent"
										(click)="cancelConversion(conversionInfo.conversionProcessInfoId)"
									>
										<mat-icon fontSet="fad" fontIcon="fa-times" inline />
									</button>
								}
							}
							<div class="statusCon">
								@switch (conversionInfo.conversionState) {
									@case (ExportState.Canceling) {
										{{ T.RECORDINGS_FILESET_PANEL_STATUS_CANCELLING | translate }}
									}
									@case (ExportState.Canceled) {
										{{ T.RECORDINGS_FILESET_PANEL_STATUS_CANCELLED | translate }}
									}
									@case (ExportState.Finished) {
										{{ T.RECORDINGS_FILESET_PANEL_STATUS_FINISHED | translate }}
									}
									@case (ExportState.Failed) {
										{{ T.RECORDINGS_FILESET_PANEL_STATUS_FAILED | translate }}
									}
									@case (ExportState.Paused) {
										{{ T.RECORDINGS_FILESET_PANEL_STATUS_PAUSED | translate }}
									}
									@case (ExportState.Idle) {
										{{ T.RECORDINGS_FILESET_PANEL_STATUS_IDLE | translate }}
									}
									@case (ExportState.Exporting) {
										<mat-progress-bar
											color="accent"
											[mode]="'determinate'"
											[value]="conversionInfo.progress * 100 | round: 2"
										/>
										<div class="statusTextForProgress">
											{{ T.RECORDINGS_FILESET_PANEL_STATUS_EXPORTING | translate }}
											{{ conversionInfo.progress * 100 | round: 2 }}
											%
										</div>
									}
								}
							</div>
						</div>
						<div class="exportStateCon">
							<div class="icon">
								@switch (conversionInfo?.conversionState) {
									@case (ExportState.Finished) {
										<i class="fad fa-2x fa-check accent"></i>
									}
									@case (ExportState.Canceled) {
										<i class="fad fa-2x fa-exclamation-triangle warn2"></i>
									}
									@case (ExportState.Canceling) {
										<i class="fad fa-2x fa-exclamation-triangle warn2"></i>
									}
									@case (ExportState.Failed) {
										<i class="fad fa-2x fa-exclamation-triangle warn"></i>
									}
									@default {
										<div class="exporting">
											<i class="fad fa-spin fa-spinner-third accent"> </i>
										</div>
									}
								}
							</div>
						</div>
					</div>
				}
			}
		</div>
	}
</div>
